module.exports = __webpack_public_path__ + "img/s4.dc33e4d8.png";